import { ProductService } from '@inter-ikea-kompis/services';
import { IShoppingItem, IShoppingProduct } from '@inter-ikea-kompis/types/lib';
import { Product, ShoppingItemWithPrice } from '@inter-ikea-storageone/range';
import { useServiceSettings } from 'contexts/serviceSettings';
import { isConfigurationPossible } from 'ducks/layout';
import { getLegacyShoppingItems } from 'ducks/products';
import { productsToShoppingItems } from 'products';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const useFetchShoppingProducts = (
  products: Product[]
): {
  shoppingProducts: IShoppingProduct[];
  shoppingItems: IShoppingItem[];
  shoppingItemsWithPrice: ShoppingItemWithPrice[];
} => {
  const { kompisSettings, productFields } = useServiceSettings();
  const configurationPossible = useSelector(isConfigurationPossible);
  const legacyShoppingItems = useSelector(getLegacyShoppingItems);
  const [shoppingProductsArray, setShoppingProductsArray] = useState<IShoppingProduct[]>([]);

  const items = productsToShoppingItems(products);
  const componentMounted = useRef(false);

  const shoppingItems: IShoppingItem[] = configurationPossible
    ? items.map(s => s.shoppingItem).slice()
    : legacyShoppingItems;

  const shoppingItemsWithPrice: ShoppingItemWithPrice[] = configurationPossible
    ? items.map(i => ({
        ...i.shoppingItem,
        price: i.product.priceInformation.currentPrice
      }))
    : legacyShoppingItems;

  const productKeys = JSON.stringify(products.map(p => p.coreProductId));

  useEffect(() => {
    componentMounted.current = true;
    async function getData() {
      const products = await new ProductService(kompisSettings).getShoppingProducts(
        shoppingItems,
        productFields
      );
      if (shoppingProductsArray !== products && componentMounted.current) {
        setShoppingProductsArray(products);
      }
    }

    getData();

    return () => {
      componentMounted.current = false;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productKeys]);

  return { shoppingProducts: shoppingProductsArray, shoppingItemsWithPrice, shoppingItems };
};

export default useFetchShoppingProducts;
